import React from 'react';
import dynamic from 'next/dynamic';
import { useTranslation } from 'react-i18next';
import IconApplestore from '../icons/Applestore';
import IconGoogleplay from '../icons/Googleplay';
import { Menu } from '@/components/ui/Menu';

const DownloadAppMenu = dynamic(() => import('./DownloadAppMenu'), { ssr: false });

const DownloadApp = () => {
    const { t } = useTranslation();

    return (
        <Menu
            role="dialog"
            ariaLabel={t('common.download_app')}
            align="end"
            side="bottom"
            menuClassName="w-[22rem] max-w-[calc(100vw-1rem)] overflow-y-auto p-0"
            content={<DownloadAppMenu />}
            trigger={(
                <button type="button" className="flex shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-2xl bg-transparent p-0.5 font-bold normal-case shadow-none">
                    <IconApplestore className="h-4 w-4" />
                    <IconGoogleplay className="h-4 w-4" />
                    {t('common.download_app')}
                </button>
            )}
        />
    );
};

export default DownloadApp;
